import type { TranscriptionResponse } from "@ui/components/demos/STT/types";

import { getCaptchaToken } from "@/app/_providers/hcaptcha/core";
import { generateSttFromUrl, STT_ERROR_MAP, type ErrorCode } from "@/app/_api/generateStt";

import type { SttTranscribeError } from "./transcribeSttFile";

export type SttUrlTranscribeResult = {
  audioUrl: string;
  sourceTitle: string;
  transcription: TranscriptionResponse;
};

export async function transcribeSttUrl({
  url,
  signal,
  with_additional_formats = true,
}: {
  url: string;
  signal?: AbortSignal;
  with_additional_formats?: boolean;
}): Promise<[error: SttTranscribeError | null, result: SttUrlTranscribeResult | null]> {
  try {
    const token = await getCaptchaToken({ behaviourType: "stt" });
    const res = await generateSttFromUrl({
      url,
      signal,
      hcaptcha_token: token,
      with_additional_formats,
    });
    return [
      null,
      {
        transcription: res.chunk,
        audioUrl: res.url,
        sourceTitle: res.source_title,
      },
    ];
  } catch (error) {
    if (error instanceof DOMException && error.name === "AbortError") {
      return ["aborted", null];
    }
    if (
      typeof error === "object" &&
      error !== null &&
      "status" in error &&
      (error as { status: string }).status in STT_ERROR_MAP
    ) {
      return [(error as { status: ErrorCode }).status, null];
    }
    return ["transcribe_failed", null];
  }
}
